export default "__VITE_ASSET__CHfVRIpS__"